// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const ReleaseButton = ({ onClick, disabled, tooltip, ...props }) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        variant="gradient"
        iconOnly
        size="small"
        type="button"
        {...props}
        color={props?.style?.backgroundColor ? null : "success"}
        style={
          disabled
            ? { background: "grey", color: "white", marginLeft: "5px" }
            : props?.style
        }
      >
        <Icon>forward</Icon>
      </MDButton>
    </Tooltip>
  );
};

export default ReleaseButton;
